import React from 'react';
import type { FunctionComponent } from 'react';
import type Teacher from '@whizz/api-client/dist/@types/model/Teacher';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { ROSTER_ROUTES, ROUTES } from '../../util/vars';
import Staff from './pages/Staff/Staff';
import Classes from './pages/Classes/Classes';
import Students from './pages/Students/Students';
import Tags from './pages/Tags/Tags';
import Tidy from './pages/Tidy/Tidy';
import UploadLegacy from './pages/Upload/Upload';
import Upload from './pages/Upload/Upload2';
import Parents from './pages/Parents/Parents';
import { useIdentity } from '@whizz/react-identity';
import { useCleverIntegration } from '../../hooks/useCleverIntegration';
const Routes: FunctionComponent = () => {
  const { path } = useRouteMatch();
  const { me } = useIdentity();
  const [ isClever ] = useCleverIntegration();

  const teacher = me as Teacher;

  if (!teacher.getIsAdmin()) {
    return <Redirect to={ROUTES.home} />;
  }
  return (
    <Switch>
      <Route path={`${path}${ROSTER_ROUTES.student}`}>
        <Students />
      </Route>
      <Route path={`${path}${ROSTER_ROUTES.staff}`}>
        <Staff />
      </Route>
      <Route path={`${path}${ROSTER_ROUTES.class}`}>
        <Classes />
      </Route>
      <Route path={`${path}${ROSTER_ROUTES.tags}`}>
        <Tags />
      </Route>
      <Route path={`${path}${ROSTER_ROUTES.upload}`}>
        { isClever
          ? <Redirect to={`${path}${ROSTER_ROUTES.student}`} />
          : <Upload />
        }
      </Route>
      <Route path={`${path}${ROSTER_ROUTES.upload_legacy}`}>
        { isClever
          ? <Redirect to={`${path}${ROSTER_ROUTES.student}`} />
          : <UploadLegacy />
        }
      </Route>
      <Route path={`${path}${ROSTER_ROUTES.parents}`}>
        <Parents />
      </Route>
      <Route path={`${path}${ROSTER_ROUTES.tidy}`}>
        <Tidy />
      </Route>
      <Route>
        <Redirect to={`${path}${ROSTER_ROUTES.student}`} />
      </Route>
    </Switch>
  );
};

export default Routes;
